import { format } from "date-fns";

import {
  toApiDatetimeString,
  toLocalDatetimeInput,
} from "./releaseNotesTransforms";

export const EMPTY_DISPLAY = "未設定";

const toValidDate = (value) => {
  if (value == null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  const normalized =
    typeof value === "string" && value.includes(" ") && !value.includes("T")
      ? value.replace(" ", "T")
      : value;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const formatPublishWindow = (publishedAt, unpublishedAt) => {
  const start = toValidDate(publishedAt);
  const end = toValidDate(unpublishedAt);
  return {
    startDate: start ? format(start, "yyyy-MM-dd") : EMPTY_DISPLAY,
    startTime: start ? format(start, "HH:mm") : EMPTY_DISPLAY,
    endDate: end ? format(end, "yyyy-MM-dd") : EMPTY_DISPLAY,
    endTime: end ? format(end, "HH:mm") : EMPTY_DISPLAY,
  };
};

export const normalizeWebsiteAnnouncementListRow = (row) => ({
  id: row.id,
  title: row.title ?? "",
  content: row.content ?? "",
  publishedAt:
    row.announcement_starts_at ??
    row.announcement_time ??
    row.published_at ??
    row.announcement_start_at ??
    null,
  unpublishedAt:
    row.announcement_ends_at ??
    row.unpublished_at ??
    row.announcement_end_at ??
    row.announcement_end_time ??
    null,
  isPublished: Boolean(row.is_published),
  isDraft: Boolean(row.is_draft),
  displayType: row.display_type ?? "",
  category: row.category ?? "",
});

const DISPLAY_TYPE_LABELS = {
  fullscreen: "全螢幕 Popup",
  popover: "右下角 Popover",
  banner: "底部跑馬燈",
};

export const getDisplayTypeLabel = (displayType) => {
  const key = String(displayType || "").trim();
  if (!key) return "";
  return DISPLAY_TYPE_LABELS[key] ?? key;
};

export const getAnnouncementStatusTypeLabels = (row) => {
  const startsAt = toValidDate(row?.publishedAt);
  const statusLabel = startsAt && startsAt.getTime() <= Date.now() ? "已上架" : "未上架";

  const cat = String(row.category || "").trim();
  const typeLabel = cat || getDisplayTypeLabel(row.displayType) || "未設定";

  return { statusLabel, typeLabel };
};

export const getAnnouncementStatusBadgeTheme = (statusLabel) => {
  if (statusLabel === "已上架") return "published";
  if (statusLabel === "未上架") return "unpublished";
  return "default";
};

export const getAnnouncementTypeBadgeTheme = (typeLabel) => {
  return "default";
};

const ALLOWED_DISPLAY_TYPES = ["fullscreen", "popover", "banner"];

export const normalizeDisplayTypeFromApi = (value) => {
  const v = String(value || "").trim();
  return ALLOWED_DISPLAY_TYPES.includes(v) ? v : "popover";
};

export const normalizeCategoryTypeFromApi = (value) => {
  const v = String(value || "").trim();
  if (v === "系統更新" || v === "發行日記") return v;
  return "系統更新";
};

export const buildWebsiteAnnouncementPayload = ({
  title,
  content,
  announcementStartLocal,
  announcementEndLocal,
  displayType,
  categoryLabel,
  redirectButtonText,
  redirectUrl,
  startFeed,
  keyFeed,
}) => {
  const safeContent = String(content ?? "").trim();
  const bodyHtml = safeContent || "<p></p>";

  const payload = {
    mode: "publish",
    title: String(title || "").trim(),
    content: bodyHtml,
  };

  const cat = String(categoryLabel || "").trim();
  if (cat) {
    payload.category = cat;
  }

  const buttonText = String(redirectButtonText || "").trim();
  const buttonUrl = String(redirectUrl || "").trim();
  payload.url_context = buttonText;
  payload.url_path = buttonUrl;

  const dt = normalizeDisplayTypeFromApi(displayType);
  payload.display_type = dt;

  const startsAt = toApiDatetimeString(announcementStartLocal);
  if (!startsAt) {
    return null;
  }
  payload.announcement_starts_at = startsAt;

  const endsAt = toApiDatetimeString(announcementEndLocal);
  payload.announcement_ends_at = endsAt ?? null;

  payload.start_feed = Boolean(startFeed);
  payload.key_feed = Boolean(keyFeed);

  return payload;
};

export const mapWebsiteAnnouncementDetailToFormValues = (data) => ({
  title: data?.title ?? "",
  content: data?.content ?? "",
  announcementStartAt: toLocalDatetimeInput(
    data?.announcement_starts_at ??
      data?.announcement_time ??
      data?.published_at ??
      "",
  ),
  announcementEndAt: toLocalDatetimeInput(
    data?.announcement_ends_at ??
      data?.unpublished_at ??
      data?.announcement_end_at ??
      "",
  ),
  displayType: normalizeDisplayTypeFromApi(data?.display_type),
  categoryType: normalizeCategoryTypeFromApi(data?.category),
  redirectButtonText:
    data?.url_context ??
    data?.cta_label ??
    data?.cta_button_text ??
    data?.button_text ??
    data?.meta_json?.cta_label ??
    "",
  redirectUrl:
    data?.url_path ??
    data?.cta_url ??
    data?.link_url ??
    data?.redirect_url ??
    data?.meta_json?.cta_url ??
    "",
  startFeed: Boolean(data?.start_feed),
  keyFeed: Boolean(data?.key_feed),
});
